export default {
  steps: {
    0: {
      title: 'Seja um habitual',
      description: 'Veja o seu histórico de encomendas e volte a encomendar com um toque.',
    },
    1: {
      title: 'Ganhe recompensas',
      description: 'Acompanhe os seus pontos e utilize as recompensas guardadas na sua carteira.',
    },
    2: {
      title: 'Encomende com antecedência',
      description: 'Encontre a localização mais próxima e encomende mais rápido do que nunca.',
    },
  },
  buttons: {
    skip: 'Ignorar',
  },
};
